<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">AMERICA AS EMPIRE</h1>
<h1 class="subtitle">GLOBAL LEADER OR ROGUE POWER?</h1><br/>
<h2 class="author">Jim Garrison</h2><br/><br/><br/><br/>
<div class="image"><img alt="image" src="images/0001.jpg"/></div>
<p class="center"><span>BERRETT-KOEHLER PUBLISHERS, INC.<br/>San Francisco</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?46e50d3f